import api from 'services/api'
import { stringifyPageQuery, uploadFile as uploadFileUtil } from 'services/utils'

export const createContractor = (newContractor) =>
  api.post('/contractors', newContractor)

export const fetchContractor = (id) =>
  api.get(`/contractors/${id}`)

export const fetchContractorFromCache = (id) =>
    api.get(`/contractors/${id}/cached`)

export const fetchContractorsPage = (params) =>
  api.get(`/contractors?${stringifyPageQuery(params)}`)

export const fetchContractorBalance = (contractorId) => api.get(`/contractor/${contractorId}/balance`)

export const deleteContractor = (id) => api.put(`/contractors/${id}/deleted`, { deleted: true })

export const editContractor = ({ id, ...updatedContractor }) =>
  api.put(`/contractors/${id}`, updatedContractor)

export const uploadFile = (file) => {
  return uploadFileUtil(file, '/contractors/files')
}

export const fetchContractorUpdateHistory = (id) => api.get(`/contractors/${id}/update-history`)

export const fetchContractorEmails = (id) => api.get(`/contractors/${id}/emails`)

export const fetchCarrierLatestEmails = (id) => api.get(`/contractors/${id}/emails/suggestions`)

export const addContractorEmail = (id, email) => api.post(`/contractors/${id}/emails`, {email})

export const verifyContractor = (contractorId, comment) =>
  api.post(`/contractors/${contractorId}/verify`, {comment})